import { GlobalAxios } from "../axios/axios-config";

const FORUBUS_VACCINE_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ForubusVaccine/RestartForubusVaccine";

export const restartForubusVaccineRetries = ({
  identifier,
  identifierList,
}: {
  identifier?: number;
  identifierList?: number[];
}) => {
  return GlobalAxios.put(FORUBUS_VACCINE_ROUTE, {
    identifier,
    identifierList,
  });
};
